/* SANO — MARINUS CRO. Apenas apresentação; sem pixels, encomendas automáticas ou preços fixos. */
(function () {
  'use strict';

  function initialise(root) {
    if (!root || root.dataset.croReady === 'true') return;
    root.dataset.croReady = 'true';
    var form = root.querySelector('.sano-cro__form');
    if (!form) return;
    var choices = form.querySelectorAll('input[type="radio"][name="id"]');
    var buy = form.querySelector('[data-cro-buy]');
    var summary = form.querySelector('[data-cro-summary]');
    var total = form.querySelector('[data-cro-total]');
    var sticky = root.querySelector('[data-cro-sticky]');
    var image = root.querySelector('[data-cro-main-image]');
    var isProduct = root.dataset.productView === 'true';
    var buyVisible = true;
    var afterBuy = false;
    var choicesVisible = false;
    var choiceEngaged = false;
    var mobile = window.matchMedia('(max-width: 749px)');

    function selectedChoice() {
      return form.querySelector('input[type="radio"][name="id"]:checked');
    }

    function refreshSticky() {
      if (!sticky || !buy) return;
      var cookieBanner = document.querySelector('#shopify-pc__banner, [id*="shopify-pc__banner"]');
      var cookiesVisible = cookieBanner && cookieBanner.getBoundingClientRect().height > 0;
      var usefulMoment = afterBuy || (choicesVisible && choiceEngaged);
      sticky.hidden = !mobile.matches || buyVisible || !usefulMoment || buy.disabled || cookiesVisible;
    }

    function updateChoice() {
      var chosen = selectedChoice();
      if (!chosen) {
        if (buy) buy.disabled = true;
        refreshSticky();
        return;
      }
      var bottles = Number(chosen.dataset.bottles);
      if (summary) summary.textContent = bottles + (bottles === 1 ? ' embalagem' : ' embalagens') + ' · ' + chosen.dataset.capsules + ' cápsulas · ' + chosen.dataset.days + ' dias à dose indicada';
      if (total) total.textContent = chosen.dataset.price;
      if (buy) buy.disabled = chosen.disabled;
      if (sticky) {
        var stickyLabel = sticky.querySelector('[data-cro-sticky-label]');
        var stickyPrice = sticky.querySelector('[data-cro-sticky-price]');
        if (stickyLabel) stickyLabel.textContent = chosen.dataset.label;
        if (stickyPrice) stickyPrice.textContent = chosen.dataset.price;
      }
      if (isProduct && image && chosen.dataset.image) {
        image.removeAttribute('srcset');
        image.src = chosen.dataset.image;
        image.alt = chosen.dataset.imageAlt || image.alt;
      }
      if (isProduct && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', chosen.value);
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      }
      refreshSticky();
    }

    choices.forEach(function (choice) {
      choice.addEventListener('change', function () { choiceEngaged = true; updateChoice(); });
      choice.addEventListener('click', function () { choiceEngaged = true; updateChoice(); });
    });

    /* O formulário Liquid envia o pack escolhido com quantity=1 ao carrinho Shopify.
       Não intercetar o submit: a compra continua a funcionar sem JavaScript. */
    form.addEventListener('submit', function (event) {
      var chosen = selectedChoice();
      if (!chosen || chosen.disabled) {
        event.preventDefault();
        return;
      }
      if (buy) buy.setAttribute('aria-busy', 'true');
    });

    if (sticky && buy && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        buyVisible = entries[0].isIntersecting;
        afterBuy = entries[0].boundingClientRect.bottom < 0;
        refreshSticky();
      }, { threshold: 0 });
      observer.observe(buy);
      var choiceGroup = form.querySelector('fieldset');
      if (choiceGroup) {
        var choicesObserver = new IntersectionObserver(function (entries) {
          choicesVisible = entries[0].isIntersecting;
          refreshSticky();
        }, { threshold: 0 });
        choicesObserver.observe(choiceGroup);
      }
      window.addEventListener('resize', refreshSticky, { passive: true });
      document.addEventListener('visitorConsentCollected', refreshSticky);
      window.addEventListener('pageshow', function () {
        if (buy) buy.removeAttribute('aria-busy');
        refreshSticky();
      });
    }

    updateChoice();
  }

  function boot() {
    document.querySelectorAll('[data-sano-cro]').forEach(initialise);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
}());

/* Recortes MARINUS nesta cópia do tema. Não altera produtos ou outros ficheiros. */
(function () {
  'use strict';
  var cutouts = [{"match": "marinus-sano-calcio-magnesio-120-capsulas-nova-embalagem", "url": "https://files.manuscdn.com/user_upload_by_module/session_file/310419663028612399/IhorPionUvDkovWn.webp"}, {"match": "marinus-sano-pack-3-embalagens", "url": "https://files.manuscdn.com/user_upload_by_module/session_file/310419663028612399/zizelSwUKnXrNcMt.webp"}, {"match": "marinus-sano-pack-6-embalagens", "url": "https://files.manuscdn.com/user_upload_by_module/session_file/310419663028612399/clZgnLkCZdHTDdqq.webp"}];
  var attributes = ['src', 'srcset', 'data-src', 'data-srcset', 'data-original', 'data-lazy-src', 'data-lazy-srcset'];
  var queued = false;

  function updateImage(image) {
    if (image.dataset.sanoCutoutFallback === 'used') return;
    var values = attributes.map(function (name) { return image.getAttribute(name) || ''; }).join(' ');
    var replacement = cutouts.find(function (entry) { return values.indexOf(entry.match) !== -1; });
    if (!replacement) return;
    var original = image.getAttribute('src');
    attributes.forEach(function (name) { if (name !== 'src') image.removeAttribute(name); });
    var picture = image.closest('picture');
    if (picture) picture.querySelectorAll('source').forEach(function (source) { source.srcset = replacement.url; });
    image.dataset.sanoCutout = 'true';
    if (original && !image.dataset.sanoCutoutFallback) {
      image.dataset.sanoCutoutFallback = 'ready';
      image.addEventListener('error', function () {
        if (image.dataset.sanoCutoutFallback === 'ready') {
          image.dataset.sanoCutoutFallback = 'used';
          image.src = original;
        }
      }, { once: true });
    }
    if (image.getAttribute('src') !== replacement.url) image.src = replacement.url;
  }

  function refreshImages() {
    queued = false;
    document.querySelectorAll('img').forEach(updateImage);
  }

  function queueRefresh() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(refreshImages);
  }

  function start() {
    refreshImages();
    var observer = new MutationObserver(function (changes) {
      if (changes.some(function (change) { return change.type === 'childList' || change.target.tagName === 'IMG'; })) queueRefresh();
    });
    observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: attributes });
    document.addEventListener('shopify:section:load', queueRefresh);
    document.documentElement.addEventListener('cart:refresh', queueRefresh);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
